// src/utils/socket.js
import { io } from "socket.io-client";

const backendUrl = import.meta.env.VITE_BACKEND_URL;

function getBearerToken() {
  const token = sessionStorage.getItem("token");
  return token ? `Bearer ${token}` : null;
}

const socket = io(backendUrl, {
  transports: ["websocket"],
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 10000,
  auth: { token: getBearerToken() },
});

if (socket.auth?.token) {
  socket.connect();
}

// Requests buffered while the socket was disconnected — retried on reconnect
const _pendingRequests = [];

function _flushPending() {
  while (_pendingRequests.length > 0) {
    const { type, agentId, resolve, reject } = _pendingRequests.shift();
    fetchData(type, agentId).then(resolve).catch(reject);
  }
}

socket.on("connect", () => {
  console.log("[socket] connected:", socket.id);
  // Resync all agent statuses so the UI is never stale after a reconnect
  socket.emit("refresh_agent_states");
  _flushPending();
});

socket.on("disconnect", (reason) => {
  console.log("[socket] disconnected:", reason);
});

socket.on("connect_error", (err) => {
  console.warn("[socket] connect error:", err?.message || err);
});

export function fetchData(type, agentId) {
  return new Promise((resolve, reject) => {
    if (!socket.connected) {
      // Buffer the request; it will be retried automatically on reconnect
      _pendingRequests.push({ type, agentId, resolve, reject });
      return;
    }
    socket.emit("get_data", { type, agentId }, (response) => {
      if (!response) return reject("No response from server");
      if (response.success === false) return reject(response.message || "Fetch failed");
      resolve(response);
    });
  });
}

export function updateSocketToken(newToken) {
  if (socket.connected) socket.disconnect();
  socket.auth = { token: newToken ? `Bearer ${newToken}` : null };
  if (newToken) socket.connect();
}

export default socket;
